// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { MapIcon } from '@moia-dev/pace-icons'
import { MapInspectorAreaRoutes } from './MapInspectorAreaRoutes'

// Exported so the area config can expose it (e.g. the welcome page's
// recently visited areas). Keep it a plain icon reference.
export const MapInspectorAreaNavigationIcon = MapIcon

export const MapInspectorAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={MapInspectorAreaRoutes.route}
      Icon={MapInspectorAreaNavigationIcon}
    />
  )
}
